<template>
  <div>
    <el-page-header class="header" content="设备详细" @back="$router.back()" />
    <el-tabs type="border-card" v-model="activeTab">
      <el-tab-pane label="设备信息" name="one">
        <power-station-detail-one />
      </el-tab-pane>
      <el-tab-pane label="插座信息" name="four">
        <power-station-detail-four />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PowerStationDetailFour from "./PowerStationDetail/PowerStationDetailFour";
import PowerStationDetailOne from "./PowerStationDetail/PowerStationDetailOne";

export default {
  name: "PowerStationDetail",
  components: {
    PowerStationDetailOne,
    PowerStationDetailFour,
  },
  data() {
    return {
      activeTab:
        this.$route.query.activeTab == undefined
          ? "one"
          : this.$route.query.activeTab,
    };
  },
};
</script>
<style lang="sass" scoped>
.header
  margin-bottom: 10px
</style>
